import React from "react";
import "../../App.css";
import CompilerError from "../CompilerError";
import Problem from "../Problem";
import Suggestion from "../Suggestion";
import BadExample from "../BadExample";
import GoodExample from "../GoodExample";
import NonStaticFromStaticResourceFooter from "../resourceFooters/NonStaticFromStaticResourceFooter.jsx";
import { makeClassStubIfUnknown } from "../../demoValues";

class NonStaticFromStatic extends React.Component {

  render() {
    const staticClassPlaceholder = <div className="Indent-0">{makeClassStubIfUnknown(this.props.staticMethodReturnType)}</div>;
    const regularClassPlaceholder = this.props.staticMethodReturnType !== this.props.methodReturnType ? 
    <div className="Indent-0">{makeClassStubIfUnknown(this.props.methodReturnType)}</div> : "";
    const classPlaceholder = <>{staticClassPlaceholder} {regularClassPlaceholder}</>;

    // eslint-disable-next-line
    const abbreviatedComment = "/* your code */";

    return <CompilerError
      title={<>Cannot make a static reference to the non-static method {" "}
        <div className="InputValue">{this.props.methodName}() </div> from the type {this.props.fileName}</>}
      translation="You are calling on a non-static method inside a static method."
      embed={this.props.embed} 
      fontSize={this.props.fontSize}
    >
      <Problem
        title={<>You may have called on method <div className="InputValue">{this.props.methodName}() </div> {" "}
          inside your static method <div className="InputValue">{this.props.staticMethodName}()</div>.</>}
      >
        <Suggestion title={<>Make your static method <div className="InputValue">{this.props.staticMethodName}() </div> {" "}
          non-static.</>}>
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> static {this.props.staticMethodReturnType} {this.props.staticMethodName}() {"{"} </div>
            <div className="Indent-1"> {this.props.methodName}(); </div>
            <div className="Indent-0"> {"}"} </div>
            <div className="Indent-0"> {this.props.methodReturnType} {this.props.methodName}() {"{"} </div>
            <div className="Indent-1"> {abbreviatedComment} </div>
            <div className="Indent-0"> {"}"} </div>
          </BadExample>
          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.staticMethodReturnType} {this.props.staticMethodName}() {"{"} </div>
            <div className="Indent-1"> {this.props.methodName}(); </div>
            <div className="Indent-0"> {"}"} </div>
            <div className="Indent-0"> {this.props.methodReturnType} {this.props.methodName}() {"{"} </div>
            <div className="Indent-1"> {abbreviatedComment} </div>
            <div className="Indent-0"> {"}"} </div>
          </GoodExample>
        </Suggestion>
        <Suggestion title={<>Make your non-static method <div className="InputValue">{this.props.methodName}() </div> static.</>}>
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> static {this.props.staticMethodReturnType} {this.props.staticMethodName}() {"{"} </div>
            <div className="Indent-1"> {this.props.methodName}(); </div>
            <div className="Indent-0"> {"}"} </div>
            <div className="Indent-0"> {this.props.methodReturnType} {this.props.methodName}() {"{"} </div>
            <div className="Indent-1"> {abbreviatedComment} </div>
            <div className="Indent-0"> {"}"} </div>
          </BadExample>
          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> static {this.props.staticMethodReturnType} {this.props.staticMethodName}() {"{"} </div>
            <div className="Indent-1"> {this.props.methodName}(); </div>
            <div className="Indent-0"> {"}"} </div>
            <div className="Indent-0"> static {this.props.methodReturnType} {this.props.methodName}() {"{"} </div>
            <div className="Indent-1"> {abbreviatedComment} </div>
            <div className="Indent-0"> {"}"} </div>
          </GoodExample>
        </Suggestion>
      </Problem>
      <NonStaticFromStaticResourceFooter />
    </CompilerError>;
  }
}

export default NonStaticFromStatic;
